import React from "react";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const adjustWaitingTime = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.AdjustWaitingTime,
    input
  );
  return data;
};

const adjustWTROTAWaitingTime = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.WTROTAdjustWaitingTime,
    input
  );
  return data;
};

export const useAdjustWaitingTimeMutation = () => {
  return useMutation({
    mutationFn: adjustWaitingTime,
  });
};

export const useAdjustWTROTAWaitingTimeMutation = () => {
  return useMutation({
    mutationFn: adjustWTROTAWaitingTime,
  });
};
